/* ============================================================
   BOARDSOX HOME — bsx-home.js
   Behaviour for the bsx- home sections, ported from the prototype.
   Every block is guarded so sections can be removed/reordered in
   the theme editor without breaking the others.
   Cart: uses Shopify's AJAX cart (/cart/add.js) when available and
   falls back to a local demo counter outside Shopify.
   ============================================================ */
(function () {
  'use strict';

  var onShopify = typeof window.Shopify !== 'undefined' || !!(window.routes && window.routes.cart_add_url);

  /* ---------- Toast (created on demand) ---------- */
  var toastTimer;
  function getToast() {
    var t = document.getElementById('bsxToast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'bsx toast';
      t.id = 'bsxToast';
      t.innerHTML = '<span class="d"></span>Added to cart';
      document.body.appendChild(t);
    }
    return t;
  }
  function showToast(msg) {
    var t = getToast();
    if (msg) t.lastChild.textContent = msg;
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 1900);
  }

  /* ---------- Cart count ---------- */
  function setCartCount(n) {
    document.querySelectorAll('.cartc').forEach(function (c) {
      c.textContent = n;
      c.classList.toggle('on', n > 0);
    });
  }
  function refreshCartCount() {
    if (!onShopify) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      setCartCount(cart.item_count);
    }).catch(function () {});
  }

  /* ---------- Quick add ---------- */
  var demoCount = 0;
  function bindQuickAdd(root) {
    (root || document).querySelectorAll('[data-add]').forEach(function (b) {
      if (b.__bsxBound) return;
      b.__bsxBound = true;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = b.getAttribute('data-add');
        if (onShopify && variantId && /^\d+$/.test(variantId)) {
          b.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          }).then(function () {
            refreshCartCount();
            showToast('Added to cart');
            document.dispatchEvent(new CustomEvent('bsx:cart:added'));
          }).catch(function () {
            showToast('Could not add — try the product page');
          }).finally(function () { b.disabled = false; });
        } else {
          demoCount++;
          setCartCount(demoCount);
          showToast('Added to cart');
        }
      });
    });
  }

  /* ---------- Mobile menu ---------- */
  function bindMobileMenu() {
    var mm = document.getElementById('mmenu');
    var burger = document.getElementById('burger');
    var mclose = document.getElementById('mclose');
    if (!mm) return;
    if (burger) burger.addEventListener('click', function () { mm.classList.add('on'); });
    if (mclose) mclose.addEventListener('click', function () { mm.classList.remove('on'); });
    mm.querySelectorAll('[data-mlink]').forEach(function (a) {
      a.addEventListener('click', function () { mm.classList.remove('on'); });
    });
  }

  /* ---------- Desktop nav dropdowns (tap to toggle; hover via CSS) ---------- */
  function bindNavDropdowns() {
    var navexes = document.querySelectorAll('.nav .nav-ex');
    if (!navexes.length) return;
    function closeNav(except) {
      navexes.forEach(function (o) {
        if (o !== except) {
          o.classList.remove('open');
          var b = o.querySelector('.ex-top');
          if (b) b.setAttribute('aria-expanded', 'false');
        }
      });
    }
    navexes.forEach(function (nx) {
      var bt = nx.querySelector('.ex-top');
      if (!bt) return;
      bt.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = nx.classList.contains('open');
        closeNav(nx);
        nx.classList.toggle('open', !isOpen);
        bt.setAttribute('aria-expanded', String(!isOpen));
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.nav-ex')) closeNav(null);
    });
  }

  /* ---------- Hero video modal ---------- */
  function bindVideoModal() {
    var modal = document.getElementById('bsxVideoModal');
    var play = document.querySelectorAll('[data-bsx-play]');
    if (!modal || !play.length) return;
    var box = modal.querySelector('.box');
    var videoUrl = modal.getAttribute('data-video-url') || '';
    function open() {
      if (videoUrl && !modal.__bsxVideoInjected) {
        modal.__bsxVideoInjected = true;
        var embed = '';
        var yt = videoUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
        var vimeo = videoUrl.match(/vimeo\.com\/(\d+)/);
        if (yt) embed = '<iframe src="https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0" style="position:absolute;inset:0;width:100%;height:100%;border:0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
        else if (vimeo) embed = '<iframe src="https://player.vimeo.com/video/' + vimeo[1] + '?autoplay=1" style="position:absolute;inset:0;width:100%;height:100%;border:0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
        else if (/\.(mp4|webm|mov)(\?|$)/.test(videoUrl)) embed = '<video src="' + videoUrl + '" style="position:absolute;inset:0;width:100%;height:100%" controls autoplay playsinline></video>';
        if (embed) {
          var inner = box.querySelector('.inner');
          if (inner) inner.remove();
          box.insertAdjacentHTML('beforeend', embed);
        }
      }
      modal.classList.add('on');
    }
    function close() {
      modal.classList.remove('on');
      // stop playback by removing the iframe/video so audio doesn't continue
      if (modal.__bsxVideoInjected) {
        var media = box.querySelector('iframe,video');
        if (media) { media.remove(); modal.__bsxVideoInjected = false; }
      }
    }
    play.forEach(function (p) { p.addEventListener('click', open); });
    var x = modal.querySelector('.close');
    if (x) x.addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        close();
        var mm = document.getElementById('mmenu');
        if (mm) mm.classList.remove('on');
      }
    });
  }

  /* ---------- Newsletter (demo only — real Shopify form posts normally) ---------- */
  function bindNewsletter() {
    document.querySelectorAll('form[data-bsx-demo-news]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        f.style.display = 'none';
        var ok = f.parentElement.querySelector('.ok');
        if (ok) ok.classList.add('on');
      });
    });
  }

  /* ---------- Recycled-bottle grids ---------- */
  function drawBottles() {
    var BOTTLE = '<svg viewBox="0 0 10 26"><path d="M3.7 0h2.6v2.1c0 .9.3 1.3.9 1.9.9.8 1.3 1.7 1.3 3v16.4c0 1.4-1.1 2.5-2.5 2.5H4c-1.4 0-2.5-1.1-2.5-2.5V7c0-1.3.4-2.2 1.3-3 .6-.6.9-1 .9-1.9V0z"/></svg>';
    document.querySelectorAll('.bottlegrid').forEach(function (g) {
      var n = parseInt(g.getAttribute('data-count'), 10) || 0;
      g.innerHTML = Array(n).fill(BOTTLE).join('');
    });
  }

  function init() {
    bindMobileMenu();
    bindNavDropdowns();
    bindQuickAdd(document);
    bindVideoModal();
    bindNewsletter();
    drawBottles();
    refreshCartCount();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Re-init when the theme editor re-renders a section */
  document.addEventListener('shopify:section:load', function () { init(); });
})();
